import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function NotFound() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: 32, textAlign: 'center' }}>
      <img src="/logo.png" alt="Shortflix" style={{ height: 32, marginBottom: 28 }} onError={e => { e.target.style.display = 'none'; }} />
      <div style={{ fontWeight: 900, fontSize: 72, color: 'var(--pink)', lineHeight: 1, marginBottom: 8 }}>404</div>
      <h1 style={{ fontWeight: 800, fontSize: 20, color: 'var(--text)', marginBottom: 8 }}>Page not found</h1>
      <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 24, maxWidth: 340, lineHeight: 1.6 }}>
        The page you're looking for doesn't exist or may have moved.
      </p>
      <button onClick={() => navigate(user ? '/dashboard' : '/')} className="btn-primary" style={{ padding: '10px 22px' }}>
        {user ? 'Go to Dashboard' : 'Go to Home'} →
      </button>
    </div>
  );
}
